import PropTypes from 'prop-types';
import { nanoid } from 'nanoid';
import classNames from 'classnames';

import {
  CheckboxIcon,
  CheckboxFilledIcon,
  CheckMarkAltIcon,
  CheckboxPartialIcon,
} from '../../icons';

import styles from './_index.module.scss';

const Checkbox = ({
  className,
  'data-testid': dataTestId = 'checkbox',
  id = nanoid(),
  isChecked,
  isDisabled,
  isInverseColor,
  isPartial,
  label,
  onChange,
  title,
  value,
}) => {
  const handleChange = () => {
    if (!isDisabled) {
      onChange(value);
    }
  };

  const renderCheckboxIcon = () => {
    if (isInverseColor && isChecked) return <CheckMarkAltIcon />;
    if (isChecked) return <CheckboxFilledIcon />;
    if (isPartial) return <CheckboxPartialIcon />;
    return <CheckboxIcon />;
  };

  return (
    <div
      className={classNames(styles['checkbox'], className, {
        [styles['is-checked']]: isChecked,
        [styles['is-partial']]: isPartial,
      })}
      data-testid={dataTestId}
    >
      <input id={id} onChange={handleChange} type="checkbox" />
      <label
        className={classNames(styles['checkbox-label'], {
          [styles['is-disabled']]: isDisabled,
        })}
        htmlFor={id}
        title={title}
      >
        <div className={styles['checkbox-icon']}>{renderCheckboxIcon()}</div>
        {label}
      </label>
    </div>
  );
};

Checkbox.defaultProps = {
  onChange: () => {},
};

Checkbox.propTypes = {
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  id: PropTypes.string,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isInverseColor: PropTypes.bool,
  isPartial: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  onChange: PropTypes.func,
  title: PropTypes.string,
  value: PropTypes.any.isRequired,
};

export default Checkbox;
